
<app-back-header title="{{ 'PAGES.EMAIL_UNSUBSCRIBE.HEADER' | translate }}"
[buttonImage]="BackHeaderImageType.None"></app-back-header>
<div class="container">
  <!-- INIT -->
  @if (state === EmailDataStates.INIT) {
    <p> {{'PAGES.EMAIL_UNSUBSCRIBE.TEXT' | translate}}</p>
    <div class="spacer spacer-4"></div>
    <app-button [label]="'PAGES.EMAIL_UNSUBSCRIBE.SUBMIT' | translate" (action)="unsubscribe()"
      [fullWidth]="true">
    </app-button>
    <div class="spacer spacer-2"></div>
    <app-button [label]="'PAGES.EMAIL_UNSUBSCRIBE.CANCEL' | translate" [buttonType]="ButtonType.Secondary" (action)="dashboard()"
      [fullWidth]="true">
    </app-button>
  }

  <!-- PROGRESS -->
  @if (state === EmailDataStates.PROGRESS || state === EmailDataStates.CONFIRMATION) {
    <div class="spacer spacer-8"></div>
    <app-loading></app-loading>
    <app-button [label]="'PAGES.EMAIL_UNSUBSCRIBE.CANCEL' | translate" [buttonType]="ButtonType.Secondary" (action)="dashboard()"
      [fullWidth]="true">
    </app-button>
  }

  <!-- SUCCESS -->
  @if (state === EmailDataStates.SUCCESS) {
    <div class="spacer spacer-8"></div>
    <app-svg-icon
      class="icon"
      [src]="'icons/124/circle-check.svg'"
      [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
    ></app-svg-icon>
    <div class="spacer spacer-2"></div>
    <p class="center">{{'PAGES.EMAIL_UNSUBSCRIBE.SUCCESS' | translate}}</p>
    <div class="spacer spacer-2"></div>
    <app-button [label]="'PAGES.EMAIL_UNSUBSCRIBE.BACK_TO_DASHBOARD' | translate" (action)="dashboard()"
      [fullWidth]="true">
    </app-button>
  }

  <!-- ERROR -->
  @if (state === EmailDataStates.ERROR) {
    <div class="spacer spacer-8"></div>
    <app-svg-icon
      class="icon"
      [src]="'icons/124/circle-error.svg'"
      [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
    ></app-svg-icon>
    <div class="spacer spacer-2"></div>
    <p class="center" [innerHTML]="'PAGES.EMAIL_UNSUBSCRIBE.ERROR' | translate : {error: errorMessage}"></p>
    <div class="spacer spacer-2"></div>
    <app-button [label]="'PAGES.EMAIL_UNSUBSCRIBE.BACK_TO_DASHBOARD' | translate" (action)="dashboard()"
      [fullWidth]="true">
    </app-button>
  }


</div>
